import { cn } from '../../lib/cn';
import { Card } from '../ui';
import type { DeviceLayoutSpec } from '../../adaptivexp/framework';

type Props = {
  spec: DeviceLayoutSpec;
  className?: string;
};

export function DevicePreviewFrame({ spec, className }: Props) {
  const width = spec.max_width_px ? Math.min((spec.min_width_px + spec.max_width_px) / 2, 360) : Math.min(spec.min_width_px, 360);

  return (
    <Card padding="sm" className={cn('text-center', className)}>
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{spec.label}</p>
      <p className="text-[10px] text-slate-400">{spec.min_width_px}px+</p>
      <div
        className="mx-auto mt-3 overflow-hidden rounded-lg border-2 border-slate-300 bg-slate-50 dark:border-slate-600 dark:bg-slate-900"
        style={{ width: `${Math.min(width / 4, 200)}px`, height: spec.touch_optimized ? '120px' : '100px' }}
      >
        <div className="flex h-full flex-col p-1">
          <div className="h-2 rounded bg-slate-300 dark:bg-slate-700" />
          <div className="mt-1 flex flex-1 gap-0.5">
            {spec.explorer_visible && <div className="w-1/4 rounded bg-brand-200 dark:bg-brand-900" />}
            <div className="flex-1 rounded bg-white dark:bg-slate-800" />
            {spec.ai_panel_visible && <div className="w-1/4 rounded bg-ai-200 dark:bg-ai-900" />}
          </div>
          {spec.timeline_visible && <div className="mt-0.5 h-2 rounded bg-slate-200 dark:bg-slate-700" />}
        </div>
      </div>
      <div className="mt-2 flex flex-wrap justify-center gap-1 text-[10px] text-slate-400">
        {spec.nav_mode && <span>{spec.nav_mode}</span>}
        {spec.touch_optimized && <span>· touch</span>}
      </div>
    </Card>
  );
}
